/*
 * Copyright 2026, Airspan Networks
 * All Rights Reserved.
 */

import GeneralFilter from "../../Shared/Filter/GeneralFilter";
import { resetInventoryFilters } from "../../../store/filters/Inventory/reducer";
import { useInventoryFilter } from "./hooks";

export const InventoryFilter = () => {
  const { dispatch, filters, formControlSx, searchTooltip } = useInventoryFilter();

  return (
    <GeneralFilter
      dispatch={dispatch}
      filters={filters}
      formControlSx={formControlSx}
      resetFilters={resetInventoryFilters}
      searchScope="inventory"
      searchTooltip={searchTooltip}
    />
  );
};

export default InventoryFilter;
